<app-modal
  [isOpen]="isOpen"
  (close)="closePreview.emit()"
  className="max-w-2xl mx-auto"
>
  <!-- Preview banner -->
  <div class="flex items-center justify-between px-6 py-3 border-b border-gray-100 dark:border-gray-800">
    <div class="flex items-center gap-2 text-xs font-medium text-gray-400 uppercase tracking-wide">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
      </svg>
      Vista previa
    </div>

    <!-- Device toggle -->
    <div class="inline-flex rounded-full border border-gray-200 dark:border-gray-700 p-0.5">
      <button type="button" (click)="previewMode = 'desktop'" title="Vista escritorio"
        class="rounded-full px-2.5 py-1 text-xs transition-colors"
        [class.bg-gray-900]="previewMode === 'desktop'"
        [class.text-white]="previewMode === 'desktop'"
        [class.dark:bg-white]="previewMode === 'desktop'"
        [class.dark:text-gray-900]="previewMode === 'desktop'"
        [class.text-gray-400]="previewMode !== 'desktop'">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
        </svg>
      </button>
      <button type="button" (click)="previewMode = 'mobile'" title="Vista móvil"
        class="rounded-full px-2.5 py-1 text-xs transition-colors"
        [class.bg-gray-900]="previewMode === 'mobile'"
        [class.text-white]="previewMode === 'mobile'"
        [class.dark:bg-white]="previewMode === 'mobile'"
        [class.dark:text-gray-900]="previewMode === 'mobile'"
        [class.text-gray-400]="previewMode !== 'mobile'">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Simulated public page background -->
  <div class="bg-gray-50 dark:bg-gray-950 p-6 rounded-b-3xl">
    <div [ngClass]="previewMode === 'mobile' ? 'mx-auto w-[390px]' : 'mx-auto w-full max-w-lg'">

      <!-- Step nav: OUTSIDE the card so no clipping, always visible in multi-step -->
      @if (isMultiStep) {
        <div class="flex flex-wrap items-center gap-1.5 mb-4">
          @for (step of stepsArray; track step) {
            <button type="button" (click)="previewStep = step"
              class="flex-shrink-0 px-3 py-1 rounded-full text-xs font-medium transition-colors"
              [class.bg-brand-500]="previewStep === step"
              [class.text-white]="previewStep === step"
              [class.bg-white]="previewStep !== step"
              [class.dark:bg-gray-800]="previewStep !== step"
              [class.text-gray-600]="previewStep !== step"
              [class.dark:text-gray-400]="previewStep !== step"
              [class.shadow-sm]="previewStep !== step"
            >Paso {{ step }}</button>
          }
        </div>
      }

      <!-- Empty state: only for non-multistep with zero fields -->
      @if (!isMultiStep && visibleFields.length === 0) {
        <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-10 flex flex-col items-center justify-center text-center">
          <svg class="w-12 h-12 text-gray-300 dark:text-gray-600 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          <p class="text-sm text-gray-500 dark:text-gray-400">No hay campos visibles para previsualizar</p>
        </div>
      }

      <!-- Form card: always shown for multi-step, shown for single-step when has fields -->
      @if (isMultiStep || visibleFields.length > 0) {
        <div class="bg-white dark:bg-gray-900 p-8 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-800" [ngStyle]="containerStyle">

          <!-- Title + Description -->
          <div class="mb-6 text-center">
            <h1 class="text-2xl font-bold text-gray-900 dark:text-white">
              {{ stepTitle || state.form?.title || state.form?.name || 'Formulario' }}
            </h1>
            @if (stepDescription) {
              <p class="mt-2 text-sm text-gray-500 dark:text-gray-400 whitespace-pre-line">{{ stepDescription }}</p>
            }
            @if (stepImageUrl) {
              <img [src]="stepImageUrl" alt="" class="mt-3 mx-auto max-h-40 w-auto rounded-lg object-contain" />
            }
            @if (state.form?.description) {
              <hr class="my-3 border-gray-200 dark:border-gray-700">
              <p class="text-sm text-gray-500 dark:text-gray-400 whitespace-pre-line">{{ state.form?.description }}</p>
            }
          </div>

          <!-- Empty step placeholder -->
          @if (visibleFields.length === 0) {
            <div class="flex flex-col items-center justify-center py-8 text-center">
              <svg class="w-8 h-8 text-gray-300 dark:text-gray-600 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
              <p class="text-xs text-gray-400 dark:text-gray-500">Este paso no tiene campos</p>
            </div>
          }

          <form [ngClass]="previewMode === 'desktop' ? 'grid grid-cols-3 gap-x-4 gap-y-5' : 'grid grid-cols-1 gap-y-5'"
            [ngStyle]="containerStyle" (submit)="$event.preventDefault()">
            @for (field of visibleFields; track field.fieldKey) {
              <div [class]="previewMode === 'mobile' ? 'col-span-1' : columnClass(field.columnSpan)">

                @switch (field.fieldType) {

                  @case ('CHECKBOXES') {
                    <fieldset>
                      <legend class="block text-sm font-medium mb-2" [ngStyle]="labelStyle">
                        {{ field.label }}
                        @if (isFieldRequired(field)) { <span class="text-error-500 ml-0.5">*</span> }
                      </legend>
                      <div class="space-y-2">
                        @for (opt of field.options; track opt.optionValue) {
                          <label class="flex items-center gap-2.5 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
                            <input type="checkbox" class="w-4 h-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500"
                              (change)="toggleCheckboxValue(field.fieldKey, opt.optionValue, $any($event.target).checked)" />
                            {{ opt.optionLabel }}
                          </label>
                        }
                      </div>
                    </fieldset>
                  }

                  @case ('RADIO') {
                    <fieldset>
                      <legend class="block text-sm font-medium mb-2" [ngStyle]="labelStyle">
                        {{ field.label }}
                        @if (isFieldRequired(field)) { <span class="text-error-500 ml-0.5">*</span> }
                      </legend>
                      <div class="space-y-2">
                        @for (opt of field.options; track opt.optionValue) {
                          <label class="flex items-center gap-2.5 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
                            <input type="radio" [name]="field.fieldKey" [value]="opt.optionValue"
                              class="w-4 h-4 border-gray-300 text-brand-500 focus:ring-brand-500"
                              (change)="setFieldValue(field.fieldKey, opt.optionValue)" />
                            {{ opt.optionLabel }}
                          </label>
                        }
                      </div>
                    </fieldset>
                  }

                  @case ('GDPR_CONSENT') {
                    <label class="flex items-start gap-3 cursor-pointer">
                      <input type="checkbox" class="mt-0.5 w-4 h-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 flex-shrink-0"
                        (change)="setFieldValue(field.fieldKey, $any($event.target).checked ? '1' : '')" />
                      <span class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed" [ngStyle]="labelStyle">{{ field.label }}</span>
                    </label>
                  }

                  @case ('FILE_UPLOAD') {
                    <div>
                      <label class="block text-sm font-medium mb-1.5" [ngStyle]="labelStyle">
                        {{ field.label }}
                        @if (isFieldRequired(field)) { <span class="text-error-500 ml-0.5">*</span> }
                      </label>
                      <label class="flex flex-col items-center justify-center w-full h-28 border-2 border-dashed border-gray-200 dark:border-gray-700 rounded-xl cursor-pointer bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <div class="flex flex-col items-center gap-1.5">
                          <svg class="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
                          </svg>
                          <p class="text-sm text-gray-500 dark:text-gray-400">Haz clic para subir</p>
                        </div>
                        <input type="file" class="hidden" />
                      </label>
                    </div>
                  }

                  @default {
                    <div>
                      <label class="block text-sm font-medium mb-1.5" [ngStyle]="labelStyle">
                        {{ field.label }}
                        @if (isFieldRequired(field)) { <span class="text-error-500 ml-0.5">*</span> }
                      </label>

                      @switch (field.fieldType) {
                        @case ('TEXTAREA') {
                          <textarea [placeholder]="field.placeholder || ''" rows="3" [ngStyle]="inputStyle"
                            (input)="setFieldValue(field.fieldKey, $any($event.target).value)"
                            class="w-full px-4 py-2.5 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:bg-white dark:focus:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 transition-all resize-none"></textarea>
                        }
                        @case ('DROPDOWN') {
                          <select [ngStyle]="inputStyle"
                            (change)="setFieldValue(field.fieldKey, $any($event.target).value)"
                            class="w-full px-4 py-2.5 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:bg-white dark:focus:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 transition-all">
                            <option value="">{{ field.placeholder || 'Selecciona una opción' }}</option>
                            @for (opt of field.options; track opt.optionValue) {
                              <option [value]="opt.optionValue">{{ opt.optionLabel }}</option>
                            }
                          </select>
                        }
                        @case ('DATE') {
                          <input type="date" [ngStyle]="inputStyle"
                            (click)="$any($event.target).showPicker?.()"
                            (focus)="$any($event.target).showPicker?.()"
                            (change)="setFieldValue(field.fieldKey, $any($event.target).value)"
                            class="w-full px-4 py-2.5 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:bg-white dark:focus:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 transition-all dark:[color-scheme:dark] cursor-pointer" />
                        }
                        @case ('NUMBER') {
                          <input type="number" [placeholder]="field.placeholder || ''" [ngStyle]="inputStyle"
                            (input)="setFieldValue(field.fieldKey, $any($event.target).value)"
                            class="w-full px-4 py-2.5 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:bg-white dark:focus:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 transition-all" />
                        }
                        @case ('PHONE') {
                          <input type="tel" [placeholder]="field.placeholder || ''" [ngStyle]="inputStyle"
                            (input)="setFieldValue(field.fieldKey, $any($event.target).value)"
                            class="w-full px-4 py-2.5 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:bg-white dark:focus:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 transition-all" />
                        }
                        @case ('RATING_NPS') {
                          <div class="space-y-2">
                            <div class="flex gap-1.5 flex-wrap">
                              @for (score of npsScores; track score) {
                                <button type="button" (click)="selectNps(field.fieldKey, score)"
                                  class="w-9 h-9 rounded-lg text-sm font-medium border transition-colors"
                                  [class.border-brand-500]="previewNpsSelected[field.fieldKey] === score"
                                  [class.bg-brand-500]="previewNpsSelected[field.fieldKey] === score"
                                  [class.text-white]="previewNpsSelected[field.fieldKey] === score"
                                  [class.border-gray-200]="previewNpsSelected[field.fieldKey] !== score"
                                  [class.bg-gray-50]="previewNpsSelected[field.fieldKey] !== score"
                                  [class.dark:bg-gray-800]="previewNpsSelected[field.fieldKey] !== score"
                                  [class.dark:border-gray-700]="previewNpsSelected[field.fieldKey] !== score"
                                  [class.text-gray-700]="previewNpsSelected[field.fieldKey] !== score"
                                  [class.dark:text-gray-300]="previewNpsSelected[field.fieldKey] !== score"
                                  [class.hover:border-brand-500]="previewNpsSelected[field.fieldKey] !== score"
                                  [class.hover:text-brand-500]="previewNpsSelected[field.fieldKey] !== score">
                                  {{ score }}
                                </button>
                              }
                            </div>
                            <div class="flex justify-between text-xs text-gray-400 px-0.5">
                              <span>Nada probable</span>
                              <span>Muy probable</span>
                            </div>
                          </div>
                        }

                        @case ('GEO_COUNTRY_REGION') {
                          <div class="space-y-2">
                            <app-country-select
                              [countries]="countries"
                              placeholder="País / región"
                              (valueChange)="setFieldValue(field.fieldKey, $event)" />
                            <select [ngStyle]="inputStyle"
                              class="w-full px-4 py-2.5 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:bg-white dark:focus:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 transition-all">
                              <option value="">Selecciona una región</option>
                            </select>
                          </div>
                        }
                        @default {
                          <input type="text" [placeholder]="field.placeholder || ''" [ngStyle]="inputStyle"
                            (input)="setFieldValue(field.fieldKey, $any($event.target).value)"
                            class="w-full px-4 py-2.5 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:bg-white dark:focus:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 transition-all" />
                        }
                      }

                      @if (field.helpText) {
                        <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">{{ field.helpText }}</p>
                      }
                    </div>
                  }

                }
              </div>
            }

            <!-- Submit (single-step) -->
            @if (!isMultiStep) {
              <div class="pt-2" [class.col-span-3]="previewMode === 'desktop'" [class.col-span-1]="previewMode === 'mobile'">
                <button type="submit"
                  class="w-full flex items-center justify-center px-6 py-3 bg-brand-500 hover:bg-brand-600 text-white font-medium rounded-xl transition-colors"
                  [ngStyle]="buttonStyle">
                  {{ submitLabel }}
                </button>
              </div>
            }
          </form>

          <!-- Navigation (multi-step): outside the form grid, always shown -->
          @if (isMultiStep) {
            <div class="flex items-center gap-3 pt-4">
              @if (previewStep > 1) {
                <button type="button" (click)="prevStep()"
                  class="flex-1 px-6 py-3 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 font-medium rounded-xl transition-colors hover:bg-gray-50 dark:hover:bg-gray-800">
                  Anterior
                </button>
              }
              @if (previewStep < totalSteps) {
                <button type="button" (click)="nextStep()"
                  class="flex-1 flex items-center justify-center px-6 py-3 bg-brand-500 text-white font-medium rounded-xl transition-colors"
                  [ngStyle]="buttonStyle">
                  Siguiente
                </button>
              } @else {
                <button type="button"
                  class="flex-1 flex items-center justify-center px-6 py-3 bg-brand-500 text-white font-medium rounded-xl transition-colors"
                  [ngStyle]="buttonStyle">
                  {{ submitLabel }}
                </button>
              }
            </div>
          }

        </div>
      }

    </div>
  </div>
</app-modal>
